import { LayoutComponent } from './layout.component';

export const LAYOUT_DECLARATIONS: any[] = [LayoutComponent];
